<template>
  <div class="mall-cart-item" :class="{ 'mall-cart-item--sold-out': item.soldOut }">
    <div class="mall-cart-item__buttons">
      <div class="mall-cart-item__check" @click="!item.soldOut && $emit('toggle')">
        <MallCheckBox :checked="selected" :disabled="item.soldOut" />
      </div>
      <MallRoundButton :label="'삭제'" @click="$emit('delete')" />
    </div>

    <div class="mall-cart-item__product">
      <div class="mall-cart-item__thumb">
        <img v-if="item.image" :src="item.image" :alt="item.name" />
        <div v-if="item.soldOut" class="mall-cart-item__thumb-dim">주문 불가</div>
      </div>
      <div class="mall-cart-item__text">
        <MallTextBadge v-if="item.soldOut" :label="'판매종료'" />
        <span class="mall-cart-item__category">{{ item.categoryLabel }}</span>
        <span class="mall-cart-item__name">{{ item.name }}</span>
      </div>
    </div>

    <div class="mall-cart-item__bottom">
      <MallQuantityStepper
        :value="item.quantity"
        :max="item.maxCount || 999"
        :disabled="item.soldOut"
        @change="$emit('quantity-change', $event)"
        @max-reached="$emit('quantity-max', $event)"
      />
      <div class="mall-cart-item__price">
        <span v-if="item.originalPrice" class="mall-cart-item__original">{{ formatPrice(item.originalPrice * item.quantity) }}</span>
        <!-- 판매종료 상품은 가격을 알 수 없어(price: null) 미노출 -->
        <span v-if="item.price !== null" class="mall-cart-item__amount">{{ formatPrice(item.price * item.quantity) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import convert from '@/utilities/convert.js'
import MallCheckBox from '@/components/new/atoms/MallCheckBox.vue'
import MallRoundButton from '@/components/new/atoms/MallRoundButton.vue'
import MallTextBadge from '@/components/new/atoms/MallTextBadge.vue'
import MallQuantityStepper from '@/components/new/molecules/MallQuantityStepper.vue'

export default {
  name: 'MallCartItem',
  components: {
    MallCheckBox,
    MallRoundButton,
    MallTextBadge,
    MallQuantityStepper,
  },
  props: {
    // { name, categoryLabel, image, price, originalPrice, quantity, soldOut, maxCount }
    item: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatPrice(price) {
      return convert.setComma(price) + '원'
    },
  },
}
</script>

<style scoped>
.mall-cart-item {
  display: flex;
  padding: 19px 15px;
  flex-direction: column;
  gap: 16px;
  border: 1px solid #E5E8EB;
  border-radius: 16px;
  background: #FFF;
}

.mall-cart-item--sold-out {
  background: #F9FAFB;
}

.mall-cart-item__buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.mall-cart-item__check {
  cursor: pointer;
}

.mall-cart-item--sold-out .mall-cart-item__check {
  cursor: default;
}

.mall-cart-item__product {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.mall-cart-item__thumb {
  position: relative;
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  border-radius: 8px;
  background: #F2F4F6;
  overflow: hidden;
}

.mall-cart-item__thumb img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.mall-cart-item__thumb-dim {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(24, 24, 28, 0.8);
  color: #FFF;
  font-family: Pretendard;
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
  white-space: nowrap;
}

.mall-cart-item__text {
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}

/* 13px 텍스트는 Figma 렌더링 기준(150% → 20px 반올림)으로 맞춤 */
.mall-cart-item__category {
  color: #8B95A1;
  font-family: Pretendard;
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
  line-height: 20px;
}

.mall-cart-item__name {
  color: #4E5968;
  font-family: Pretendard;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.mall-cart-item__bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.mall-cart-item__price {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  font-family: Pretendard;
  font-weight: var(--font-weight-medium);
  line-height: 1.5;
  text-align: right;
  white-space: nowrap;
}

.mall-cart-item__original {
  color: #B0B8C1;
  font-size: var(--font-size-sm);
  text-decoration: line-through;
}

.mall-cart-item__amount {
  color: var(--color-text-main);
  font-size: var(--font-size-md);
}

.mall-cart-item--sold-out .mall-cart-item__amount {
  color: #B0B8C1;
}
</style>



// WEBPACK FOOTER //
// src/components/new/molecules/MallCartItem.vue